import React from 'react'
import Header from './Header'

interface Page {
  children?: React.ReactNode
}

function Page({ children }: Page) {
  return (
    <div>
      <Header />
      <main>{children}</main>
    </div>
  )
}

export default Page
